const BACKEND = "https://app.benjamin-jager.de/sacha" 
const ASSETS = "/assets"

module.exports = {

	POROJECT: {
		name: "sacha"
	},
	ASSETS_PATH: ASSETS,
	BACKEND_PATH: BACKEND,
	INFO: {
		mainTitle: "Sacha Tassilo Hoechstetter",
		personal: {
			name: "Sacha Tassilo Hoechstetter",
			address: "Jahnstraße 5, 80469 München",
			phoneNo: "+49 (0)172 1008 431",
			email: {
				mailto: "sacha@sachahoechstetter.com"
			},
			ustId: "USt-IdNr.: DE813971514",
			services: [
				"photography",
				"motion",
				"art direction"
			]
		},
		contact: {
			agency: {
				text: "Represented by ",
				name: "Agentur Neubauer",
				link: "https://agenturneubauer.com",
				phone: "+49 (0)89 2729 4060",
				email: {
					mailto: "info@agenturneubauer.com"
				}
			}
		},
		social: {
			instagram: {
				url: "https://www.instagram.com/sachahoechstetter/",
				title: "follow sacha on instagram",
				alt: "instagram.com/sachahoechstetter",
				icon: `${ ASSETS }/instagram/instagram-bw`
			}
		}
	},

	VALID_ROUTES: {
		home: "/",
		contact: "/contact",
		imprint: "/imprint",
		privacy: "/privacy",
		showcase: "/showcase/:folderId"
	},
	COMPONENTS: [
		"hero", "gallery"
	],
	HERO: {
		loop: true,
		action: "scrollToHeader",
		hitArea: "logo",
	},
	HERO_ACTION: "scrollToHeader",
	HERO_HIT_AREA: "logo",
	HEADER_STYLE: "second",

	// TODO: make path props dynamic
	HEADER_NAV_ITEMS: {
		contact: {
			path: "/contact",
			title: "contact"
		}
	},
	FOOTER_NAV_ITEMS: {
		imprint: {
			path: "/imprint",
			title: "imprint"
		},
		privacy: {
			path: "/privacy",
			title: "privacy"
		}
	},
	LOGO_PATH: `${ ASSETS }/logo`,
	LOGO_FILE: "logo",
	// CSS_ROOT: {
	//   unit: 20,
	//   gap: unit * 2,
	//   pageFrame: width > 1111 ? unit * 5 : unit,
	//   item: 328
	// }
  PRELOADER: `${ ASSETS }/preloader/tail-spin.svg`

}
